export const TOGGLE_BUSINESS_FILTER = 'TOGGLE_BUSINESS_FILTER'
export const TOGGLE_ADMIN_SIDEBAR = 'TOGGLE_ADMIN_SIDEBAR'
export const CURRENT_PAGE_HEADING = 'CURRENT_PAGE_HEADING'
export const TOGGLE_ADMIN_SIDEBAR_ON_URL_CHANGE = 'TOGGLE_ADMIN_SIDEBAR_ON_URL_CHANGE'
